import { DiceComponents } from "@dndbeyond/dice-components";

import { Damage } from "../../Damage";

export default DiceComponents.withDiceRoll(Damage);
